<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M11.5 8.5C12.7426 8.5 13.75 7.49264 13.75 6.25C13.75 5.00736 12.7426 4 11.5 4C10.2574 4 9.25 5.00736 9.25 6.25C9.25 7.49264 10.2574 8.5 11.5 8.5Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.622 4C10.3131 3.12611 9.47965 2.5 8.5 2.5C7.25736 2.5 6.25 3.50736 6.25 4.75C6.25 5.99264 7.25736 7 8.5 7C8.76295 7 9.0154 6.95489 9.25 6.87197" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4 16.0002H4.75C4.75 16.0002 7.44752 16.9302 9.25 16.7502C11.1748 16.5579 14.296 14.7811 15.5022 14.056C15.8155 13.8677 16 13.5289 16 13.1633C16 12.4465 15.309 11.9324 14.6225 12.1384L9.25 13.7502" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4 11.875L6.93687 10.896C7.22595 10.7997 7.53158 10.7631 7.83524 10.7883L10.9275 11.046C11.4336 11.0883 11.7914 11.5599 11.6955 12.0586C11.5753 12.6834 11.118 13.1896 10.5086 13.3724L9.25 13.75" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'BountiesIcon',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    }
  }
}
</script>

<style scoped></style>